export default {
  topHeader: {
    buttonText: '前往 App',
    shareImg: '/webAssets/images/img/browser_TW.png'
  },
  articles: {
    likes: '讚',
    comments: '評論',
    reply: '回覆',
    noData: '已經全部加載完畢'
  },
  brandAuth: {
    htmlTitle: '成為認證用戶',
    bannerImg: '/webAssets/images/brand/banner2.jpg',
    textInfo: [
      '加入名廚認證',
      '獲得名廚品牌認證，即可在 APP 上展示您的產品，與各類廚師互動、參與名廚直播、食材試用等多項活動。',
      '上傳認證申請後，將會有名廚團隊專人與您聯繫。'
    ],
    formText: {
      nameText: { label: '申請人姓名', placeholder: '請輸入申請人姓名' },
      unitText: { label: '公司名稱', placeholder: '請輸入公司名稱' },
      telText: { label: '手機號碼', placeholder: '請輸入手機號碼' },
      desText: { label: '品牌簡介', placeholder: '請輸入品牌簡介' },
      submitText: { label: '上傳申請', placeholder: '上傳成功', dbApply: '不得重複上傳申請' }
    }
  },
  // 2020名厨个人年度报告
  AnnualReportIndex: {
    title: {
      a1: '我的名廚',
      a2: '年度報告'
    },
    cycle: '資料統計期間 2020.01.01 - 2020.12.31',
    agreement: {
      a1: '我已同意',
      a2: '「名廚用戶隱私協議」'
    },
    viewReport: '立即開啟',
    agreementChecked: '您尚未同意相關隱私協議，無法開啟年度報告'
  },
  walkTogether: {
    text1: '累積到現在，',
    text2: {
      a1: '我和已經',
      a2: '名廚',
      a3: '一起走過',
      a4: '天'
    },
    text3: {
      a1: '我第一次打開',
      a2: '名廚'
    }
  },
  annualReport: {
    chefType: [
      {
        i: '我是',
        a: '廚師',
        type: '影響型',
        title: '樂於展現',
        info: '在產業中佔有一席之地，會主動分享觀點與專業知識，積極交流合作'
      },
      {
        i: '我是',
        a: '廚師',
        type: '目標型',
        title: '積極累積',
        info: '在產業中具備專業能力，積極累積更多元知識，並願意投資自己學習與成長'
      },
      {
        i: '我是',
        a: '廚師',
        type: '探索型',
        title: '探索各種可能',
        info: '充滿好奇心，對未來抱持各種開放心態。積極與人交流，嘗試各種職涯可能，廣泛吸收不同烹飪風格與技巧'
      },
      {
        i: '我是',
        a: '廚師',
        type: '穩定型',
        title: '維持穩定',
        info: '擁有穩定的事業與職位狀態，追求安穩的工作表現與生活'
      },
      {
        i: '我是',
        a: '廚師',
        type: '工作型',
        title: '停滯不前，需要成長',
        info: '單純視廚師為一份工作，對於成長尚未有積極想法與做法。所處環境也較為封閉，沒有太多機會接觸新知所需'
      }
    ],
    shareBtn: '分享',
    goIndex: '重看報告',
    keepPic: '儲存圖片',
    shareXcx: '長按圖片，直接分享給好友'
  },
  review: {
    text1: {
      a1: '特別的 2020',
      a2: '終於要結束了',
      a3: '讓我來回顧一下吧'
    }
  },
  open: {
    text1: {
      a1: '2020 年',
      a2: '我打開名廚',
      a3: '次'
    },
    text2: {
      a1: '是我打開最久的一天',
      a2: '記得這特別的一天嘛？'
    }
  },
  missed: {
    text1: {
      a1: '歡迎回來，',
      a2: '2020 年都沒有出現',
      a3: '從現在開始吧'
    },
    text2: {
      a1: '有以下眾多功能幫助您提醒自己',
      a2: '瀏覽作品、文章',
      a3: '收藏作品、評論與按贊',
      a4: '收看直播、申請是用',
      a5: '使用其他高級功能',
      a6: '發佈作品與靈感'
    },
    chefBtn: '開啟名廚之路'
  },
  welcomeJoin: {
    text1: {
      a1: '歡迎加入',
      a2: '名廚！',
      a3: '從現在累積自己的料理作品吧，'
    },
    text2: {
      a1: '還有以下眾多功能',
      a2: '瀏覽作品、文章',
      a3: '收藏作品、評論與按贊',
      a4: '收看直播、申請是用',
      a5: '使用其他高級功能',
      a6: '發佈作品與靈感'
    },
    chefBtn: '开启我的Chef之路'
  },
  oftenImmersed: {
    isTrue: '答對了！',
    isError: '只差一點點',
    h4: '我常常瀏覽',
    choose: '猜猜哪一項你最投入？',
    more: {
      a1: '投入程度超過了',
      a2: '的用戶'
    },
    CreationsandInspiration: '作品和靈感',
    LiveStreaming: '直播',
    Articles: '內容',
    Collections: '專題',
    Videos: '影音',
    one: {
      a1: '您對',
      a2: '情有獨鍾'
    },
    beMore: '未來更常使用名廚 App，就能提升投入程度'
  },
  interestedCuisine: {
    title: '我最感興趣的料理類型'
  },
  myFavoriteWorks: {
    title: '我最喜愛的作品',
    views: {
      a1: '瀏覽了 ',
      a2: ' 次，互動了 '
    }
  },
  myFavoriteWorksList: {
    title: '我最喜愛的作品合輯',
    saveCollection: '保存作品合辑',
    tip: '儲存到我的收藏',
    myfavoriteof2020: '#2020 年度我最喜愛的作品合輯'
  },
  creationTimes: {
    text1: {
      a1: '我創作了',
      a2: '道作品和靈感',
      a3: '完整作品佔',
      a4: '靈感佔'
    },
    text2: {
      a1: '創作力',
      a2: '>',
      a3: '用戶'
    },
    text3: {
      a1: '在 App 上傳更多優秀作',
      a2: '品和靈感，提高你的創作力。'
    }
  },
  otherFavoriteWorks: {
    title: '最受喜愛的作品',
    views: '被瀏覽',
    likes: '次  收到',
    saves: '個讚',
    saves2: '被收藏',
    saves3: '次',
    message: {
      a1: '*喜愛度根據名廚用戶對我作品的瀏覽、收',
      a2: '藏、按讚等數字綜合計算'
    }
  },
  otherFavoriteWorksList: {
    title: '最受喜愛的作品合輯',
    saveCollection: '儲存作品合輯',
    tip: '儲存到我的收藏',
    otherfavoriteof2020: '#2020 年度最受喜愛的作品合輯'
  },
  follow: {
    title: '誰在偷偷關注我',
    choose: '猜一猜'
  },
  matchChefType: {
    title: '我的廚師類型正在分析中'
  },
  noCreation: {
    text1: {
      a1: '我創作了',
      a2: '道作品和靈感',
      a3: '尚未發過作品，超過',
      a4: '的用戶'
    },
    text2: {
      a1: '點滴累積，聚沙成塔',
      a2: '2021 加油！'
    }
  },
  annualAchievements: {
    title: '我的年度成就',
    text1: {
      a1: '影響力超過',
      a2: '的名廚用戶',
      a3: '影響力根據個人的餐飲實力，與多年來在產業中正面分享、互動、創造餐飲良好循環等行為累積而成'
    },
    text2: {
      a1: '我的作品影響了',
      a2: '獲得了',
      a3: '次推薦',
      a4: '次登上作品榜'
    },
    chefUsers: '想知道您是什麼類型的廚師嗎？',
    text3: '評估我的廚師類型',
    text4: '人已完成評估',
    text5: '回到名廚，繼續探索精彩內容',
    text6: '重看報告',
    text7: '目前影響力較低，但只要繼續在名廚 App 上互動，必定收穫豐碩！'
  },
  shareInfo: {
    title: '原來我是這種類型的廚師！立即查看你的年度報告',
    desc: '你是屬於哪一種類型的廚師呢？點入年度報告，馬上就知道！'
  },
  index2021: {
    'home': {
      title: '2020 - 2021 名廚排行榜',
      name: '2020 - 2021 名廚排行榜',
      tip: '2020 - 2021 名廚排行榜所有內容，皆以 2020 年度名廚 App 用戶行為數據作為依憑，按照不同項目分別進行計算，統計用戶的行為數據和結果。',
      share_title: '2020 - 2021 名廚排行榜',
      share_des: '12 大項名廚重點排行公布，精彩內容別錯過'
    },
    'food': { // 作品人气王
      title: '人氣作品',
      name: '人氣作品',
      tip: '名廚排行榜 2020 年最受歡迎 50 道作品<br/>評選方式：統計「作品人氣王」投票期間所得結果。',
      share_title: '2020 - 2021 名廚排行榜——人氣作品',
      share_des: '分享 2020 年 App 上最受歡迎的作品'
    },
    'chinese_food': { // 中餐
      title: '最受關注中式料理',
      name: '最受關注中式料理',
      tip: '排行本顯示 2020 年最受關注的 50 道中式料理。<br/>評選方式：以 2020 年名廚 App 中所有中式料理的瀏覽數、讚數、評論、被收藏等數據綜合得出。',
      share_title: '2020 - 2021 名廚排行榜——最受關注中式料理',
      share_des: '彙整名廚 App 上受關注的烹飪技巧與料理潮流'
    },
    'live': { // 直播
      title: '最受關注直播節目',
      name: '最受關注直播節目',
      tip: '排行榜條列 2020 最受關注的 20 場直播活動。<br/>評選方式：為 2020 年名廚 App 上所有直播影片的觀看人數、回應數、收藏與分享數等綜合計算結果。',
      share_title: '2020 - 2021 名廚排行榜——最受關注直播',
      share_des: '彙整名廚 App 上受關注的直播節目'
    },
    'condiment': { // 调味品
      title: '最受關注調味料',
      name: '最受關注調味料',
      tip: '名廚排行榜將展示 2020 最受關注的前 20 項調味料。<br/>評選方式：2020 年名廚 App 上所發佈的作品中主食材、配料和調味料等數據綜合計算比較。',
      share_title: '2020 - 2021 名廚排行榜——最受關注調味料',
      share_des: '彙整名廚 App 上受到最多人使用的調味料'
    },
    'dessert': { // 甜品
      title: '最受關注甜點',
      name: '最受關注甜點',
      tip: '排行榜將展示 2020 年最受關注的 50 道甜點作品。<br/>評選方式：以 2020 年名廚 App 發布的中式料理之外作品的瀏覽量、讚數、評論、收藏與分享等數據綜合計算結果。',
      share_title: '2020 - 2021 名廚排行榜——最受關注甜點',
      share_des: '彙整名廚 App 上受關注的烹飪技巧與料理潮流'
    },
    'first': { // 首发作品
      title: '最受關注的名廚首發',
      name: '最受關注的名廚首發',
      tip: '排行榜將展示 2020 最受關注的首發作品。<br/>評選方式：以 2020 年名廚 App 發布的中式料理之外作品的瀏覽量、讚數、評論、收藏與分享等數據綜合計算結果。',
      share_title: '2020 - 2021 名廚排行榜——最受關注首發作品',
      share_des: '彙整名廚 App 上受關注的烹飪技巧與料理潮流'
    },
    'ingredient': { // 食材
      title: '最受關注食材',
      name: '最受關注食材',
      tip: '排行榜彙整 2020 年最受關注的 20 項食材。<br/>評選方式：2020 年名廚 App 上所發佈的作品中主食材、配料和調味料等數據綜合計算比較。',
      share_title: '2020 - 2021 名廚排行榜——最受關注食材',
      share_des: '彙整名廚 App 上受到最多人使用的食材'
    },
    'chef': { // 厨师人气王
      title: '人氣廚師',
      name: '人氣廚師',
      tip: '名廚排行榜顯示 2020 最受關注的 50 位廚師<br/>評選方式：統計「人氣名廚」投票期間所得結果。',
      share_title: '2020 - 2021 名廚排行榜——人氣廚師',
      share_des: '看看誰是年度最受歡迎的人氣廚師'
    },
    'brand': { // 品牌
      title: '最受關注品牌',
      name: '最受關注品牌',
      tip: '排行榜將標註 2020 最受關注的 10 個註冊品牌。<br/>評選方式：為 2020 年名廚 App 上註冊品牌的相關直播數、試用、發布動態數等綜合計算結果。',
      share_title: '2020 - 2021 名廚排行榜——最受關注品牌',
      share_des: '彙整名廚 App 上受關注的品牌'
    },
    'user': { // 名厨达人
      title: '名廚達人',
      name: '名廚達人',
      tip: '排行榜將標註 2020 最受關注的前 50 名廚藝達人。<br/>評選方式：以 2020 年用戶上傳於名廚 App 中與他人互動交流等計算評估。',
      share_title: '2020 - 2021 名廚排行榜——名廚達人排行',
      share_des: '整理今年最活躍的名廚達人'
    },
    'non_chinese_food': { // 非中餐
      title: '最受關注作品',
      name: '最受關注作品',
      tip: '排行榜將排列 2020 年最受關注的前 50 道料理。<br/>評選方式：以 2020 年名廚 App 發布的中式料理之外作品的瀏覽量、讚數、評論、收藏與分享等數據綜合計算結果。',
      share_title: '2020 - 2021 名廚排行榜——最受關注料理',
      share_des: '彙整名廚 App 上受關注的烹飪技巧與料理潮流'
    },
    'author': { // 出品人
      title: '年度創作者',
      name: '年度創作者',
      tip: '排行榜將標註 2020 年最受關注的 50 位廚師。<br/>評選方式：以 2020 年用戶發布在名廚 App 的作品質量等結果得出。',
      share_title: '2020 - 2021 名廚排行榜 —— 年度創作者',
      share_des: '今年最受關注創作者'
    },
    vote: {
      showText: '排行榜揭曉於',
      openText: '投票始於',
      nowText: '火熱投票截止至',
      endText: '投票結束，敬請期待'
    },

    classText: '',
    topTitleClass: 'icon_top_fn',
    bottomDes: '名廚保留對於排行榜整理與解釋權利。',
    gobackBtn: '返回排行榜頁面',
    saveBtn: '儲存作品合輯',
    savedBtn: '已儲存到我的收藏',
    saveText: '收藏',
    savedText: '已收藏',
    followText: '追蹤',
    followingText: '已追蹤',
    followingAllText: '互相追蹤',
    timesUsedText: '使用次數',
    voteText: '投票'
  },
  auth: {
    home: {
      bannerText1: '名廚用戶認證',
      bannerText2: '認證後<br>能獲得更多相關福利！',
      nameText1: '實名認證',
      nameText2: '提升帳號安全性<br>獲得更多推播機會<br>官方收錄作品',
      opnText1: '工作職業認證',
      opnText2: '專屬認證標章<br>首頁推薦作品<br>活動優先參與資格',
      bnsText1: '品牌用戶認證',
      bnsText2: '增加品牌曝光<br>發布品牌專屬活動<br>精準用戶行銷',
      authHelp: '常見問題',
      authSuccess: '認證成功',
      authWait: '審核中',
      authFail: '認證失敗',
      authNo: '尚未認證'
    },
    aiAuth: {
      title1: '真實姓名認證',
      title2: '人臉識別',
      formText1: '真實姓名',
      placeholder1: '請輸入您的真實姓名',
      formText2: '證件類型',
      placeholder2: '請選擇認證類型',
      formText3: '認證號碼',
      placeholder3: '請輸入您的證件號碼',
      nextText: '下一步',
      cardText1: '中國大陸身份證',
      cardText2: '港澳台身分證、駕照、護照',
      cardText3: '海外身分證、駕照、護照',
      cancel: '取消',
      aiText1: '將進行人臉識別認證',
      aiText2: '已經閱讀並同意',
      aiText22: '名廚隱私權相關內容',
      aiText3: '開始認證',
      againAuth: '再試一次',
      statusTip1: '認證失敗',
      statusTip2: '認證成功',
      statusTip3: '重新進行人臉認證',
      statusTip4: '名廚已經加密處理您的訊息',
      statusTip5: '人工審核請點此',
      statusTip6: '訊息安全保護中，未經您的許可不對外提供',
      statusTip7: '您也可以上傳身分證或其他證件進行人工審核，審核需要約 2-3 個工作天',
      statusTip8: '所有資料僅作為名廚平台中認證使用'
    },
    nameAuth: {
      formText4: '認證照片',
      formText44: '範例',
      formText5: '證件上傳範例',
      formText6: '查看範例',
      formTip1: '請上傳您的身分證照片，確保訊息清晰，並與提交的申請資訊一致',
      btnText1: '提交認證',
      statusTip1: '審核需要 2 個工作天，請耐心等待',
      statusTip2: '請按照申請錯誤提示，並重新繳交相關資訊',
      statusTip3: '或也可以試試看',
      statusTip33: '人臉辨識認證',
      statusTip4: '請上傳其中一種類別的證件，確認姓名、單位、職稱等顯示清晰',
      statusTip5: '請上傳認證證件，確認姓名、單位、職稱等顯示清晰，並與提供之證件一致',
      imgTip1: '身分證正面',
      imgTip2: '身分證反面',
      imgTip3: '港澳台身分證',
      imgTip4: '護照',
      imgTip5: '駕照',
      isKnow: '我知道了'

    },
    opnAuth: {
      title: '餐飲工作者認證',
      iconText1: '專屬標誌',
      iconText2: '首頁曝光',
      iconText3: '優先參與活動',
      iconText4: '更多福利',
      titleText: '申請條件',
      titleText1: '目前身份',
      titleText2: '實名認證',
      titleText22: '未完成實名認證',
      titleText3: '粉絲數量',
      itleText33: '目前粉絲數量',
      titleText4: '完整作品',
      titleText44: '目前數量',
      statusText1: '前往認證',
      statusText2: '已符合條件',
      statusText3: '尚未符合',
      statusText4: '已完成實名認證',
      statusText5: '已認證',
      statusText6: '現在申請',
      formText1: '工作單位',
      formText2: '職位名稱',
      formText3: '上傳',
      formTip1: '請上傳其中一種類別的證件，確認姓名、單位、職稱等顯示清晰，並與提供之證件一致',
      formTip2: '工作在職證明',
      formTip3: '工作證件',
      formTip4: '名片',
      formTip5: '下載上述文字聲明',
      formTip55: '請下載「在職證明檔案」並蓋章後上傳，進行認證',
      formTip6: '證件上傳範例',
      formTip7: '請確認姓名、公司、職稱等資訊清楚顯示',
      formTip8: '需要手持紙本名片進行拍攝，並確保姓名、公司職位以及手機號碼清楚顯示。',
      formTip9: '請拍照上傳認證證件，確認姓名、單位、職稱等顯示清晰，並與提供之證件一致',
      identityText1: '廚師',
      identityText2: '品牌供應商',
      identityText3: '經營者',
      identityText4: '美食愛好者',
      userText1: '用戶身份',
      userText2: '中國大陸',
      userText3: '港澳台',
      userText4: '其他',
      userText5: '身分證',
      userText6: '駕照',
      userText7: '護照'
    },
    brandAuth: {
      text0: '企業認證',
      text1: '企業商標',
      text2: '帳號名稱',
      text3: '標語',
      text4: '企業介紹',
      text5: '企業名稱',
      text6: '統一編號',
      text7: '補充資料',
      text8: '工商營業執照',
      text9: '企業正式文件',
      text10: '刪除目前帳號',
      text11: '提醒',
      text12: '帳號刪除後無法恢復',
      text13: '請上傳證件圖片。確認圖片完整清晰，與帳號資訊一致',
      text14: '請上傳證件圖片。確認圖片完整清晰，與帳號資訊內容一致',
      text14_1: '請下載「認證文件」列印並蓋章後，拍照上傳。',
      text15: '帳號訊息',
      text16: '認證資料',
      text18: '顯示更多',
      text18_1: '收起',
      text19: '請輸入',
      text20: '请说明补材料类型（选填）',
      text21: '補充資料',
      text22: '當企業原名與帳號關聯度較低時，需要補充提供關聯資訊，例如臉書藍勾勾訊息、品牌授權書等。',
      text23: '證件圖片',
      text24: '請輸入內容',
      text25: '下載',
      text26: '下載蓋章後上傳',
      text27: '上傳認證文件'
    }
  },
  bigEvent: {
    winning: {
      fabu: '發布',
      prizehead: '區分名次',
      choicespan: '得獎名單',
      btnchoice: '選擇得獎作品',
      prizebtn: '公佈獲獎名單',
      prizebtns: '得獎名單公佈',
      pluswinning: '增加排名',
      toast: '最多設置五等獎',
      onSearch: '搜尋作品 / 創作者',
      awards: '選擇得獎名單',
      numberone: ['一等獎 ', '二等獎 ', '三等獎 ', '四等獎 ', '五等獎 '],
      Tips: ['請注意', '若刪除獎項，名單也會同步移除。確認執行？', '否', ' 是'],
      Tipss: ['請注意', '是否儲存此版本？', '否', '是'],
      delete: '刪除',
      Calorific: '按作品人氣排名',
      Release: '按照發布時間排名',
      votes: '按得票數排名',
      Confirmation: '確認',
      Tip: ['請注意', '得獎名單公佈後無法修改。確定執行？', '返回修改', '公布'],
      mode: ['創作者', '獲得', '請以上得獎者在名單公佈後 3 日內，透過「名廚粉專」與名廚團隊聯繫後續事宜。']
    },
    info: {
      text1: '為你推薦',
      text3: ['人瀏覽', '人參與'],
      text3_1: '所有用戶皆可參加',
      text4: '活動介紹',
      text5: '作品',
      text6: '追蹤',
      text7: '活動獎項',
      text8: '參加方式',
      text9: '溫馨提醒',
      text10: '相關推薦',
      text11: '熱門',
      text12: '最新',
      text12_1: '尚無作品',
      text13: '距离开始还有：',
      text14: '現在參加',
      text14_1: '請先將 App 更新至最新版本再參與活動，謝謝',
      text14_2: '現在更新',
      text14_3: '稍後更新',
      text14_4: ['最多可參加', '次'],
      text15: '活動選評中',
      text15_1: '選評結束',
      text16: '活動已結束',
      text17: '其他預告',
      text18: '進行中',
      text19: '選評中',
      text20: '已結束',
      text22: '您正在參加：',
      text23: '已參加',
      text24: '參加活動',
      text25: '作品選評',
      text26: '結果公布',
      text27: '票數',
      text28: '前 10 人氣',
      text29: '每人每日最多投 10 票',
      text29_1: '每人最多投 x 票',
      text30: ['這份作品正參加', '，投一票給師傅吧 >>'],
      text30_1: ['本作品正在參加', '，馬上看更多 >>'],
      text31: ['我是', '正在参与', '活動'],
      text31_1: '分享活動',
      text31_2: '為自己拉票',
      text31_3: '取消',
      text32: '名次',
      text33: '票數',
      text34: '距上一名',
      text35: '邀請好友投票',
      text35_1: '投我一票吧！',
      text35_2: '現在去支持',
      text35_3: '看更多活動詳情',
      text36: '投票給師傅',
      text36_1: '幫我拉票',
      text37: '查看得獎名單',
      text37_1: '選擇你想要拉票的作品（單選）',
      text37_2: '暫無活動介紹',
      text38: '入選作品',
      text39: '得獎名單',
      text40: '活動',
      text41: '活動管理',
      text42: '審核未通過',
      text43: '審核中',
      text44: '已上線',
      text45: '活動管理',
      text46: '活動詳情',
      text47: '發布活動',
      text48: '現在發起活動，讓更多好食譜相互交流！',
      text49: '活動管理',
      text50: '活動編輯',
      text50_1: ['活動發布後無法直接更改，若有需求請私訊名廚粉專，謝謝', '了解'],
      text50_2: '活動已進入審核階段，無法更改。若有需要，請聯繫名廚粉絲專頁',
      text51: '得獎名單',
      text51_1: '選評結束後才可公布獲獎名單',
      text52: '更多',
      text52_1: '資訊中心',
      text53: '作品數',
      text54: '參加人數',
      text55: '瀏覽人數',
      text56: '收藏人數',
      text57: '活動投票',
      text58: '轉發',
      text59: '删除',
      text59_1: ['您確認要刪除嗎？', '是', '否'],
      text59_2: ['因已有用戶參與無法刪除', '了解'],
      text60: '發布活動',
      text61: '選擇活動類型',
      text62: ['線上活動', '不需報名，用戶可以直接參加，也可以配合投票、選評等規則，選出得獎名單。'],
      text63: '查看範例',
      text64: '更多活動類型即將釋出',
      text65: '編輯封面',
      text66: '點此上傳圖片',
      text67: '尺寸：250*121，單張圖小於 5M',
      text68: ['活動資訊', '活動名稱'],
      text69: '活動類型',
      text70: '時間',
      text70_1: '請選擇活動時間',
      text70_2: '開始時間不能早於現在時間',
      text70_3: '結束時間不能早於開始時間',
      text71: '是否有評選環節',
      text72: '評選時間',
      text73: '評選規則',
      text74: '評選方式',
      text74_1: '用戶投票',
      text74_2: '評選',
      text75: '投票用戶身份',
      text75_1: '一般用戶',
      text75_2: '認證用戶',
      text75_3: '無限制',
      text76: '每人每次投票次數',
      text77: '每人投票數限制',
      text78: '結果公佈時間',
      text79: '活動標籤',
      text80: '參加活動次數',
      text81: '儲存草稿',
      text81_1: '儲存成功',
      text82: '預覽',
      text83: '下一步',
      text84: '是否有活動獎品',
      text85: '發布',
      text85_1: ['請簡單敘述活動內容和亮點',
        '若有相關設定，請填寫本活動獎項',
        '請詳述如何參與本活動',
        '請備註需要注意事項或是特殊需求'],
      text85_2: ['活動上架需經過名廚平台審核，我們將在 48 小時內處理並透過 App 通知您。再請留意查收，謝謝。',
        '了解'],
      text85_3: '您输入的内容超出字数限制～',
      text85_4: ['文字', '圖片'],
      text86: ['我已經閱讀', '《名廚活動發布規範》', '，保證活動真實並且有效'],
      text86_1: ['是否儲存此版本？', '是', '否'],
      text86_2: '請選擇圖片',
      text86_3: '請填寫活動名稱',
      text86_4: '選擇用戶參與時間',
      text86_5: '選擇選評時間',
      text86_6: '選擇結果公佈時間',
      text87_1: '上一步',
      text87_2: '發布',
      text87_3: '頁面僅供預覽，無法點選',
      text88_1: '審核中',
      text88_2: '活動審核中，名廚團隊將在 48 小時內審核完畢',
      text89: '審核未通過，請修改',
      text89_1: '活動申請未通過，請修改後再次提交',
      text90: '此活動已被主辦單位移除',
      text90_1: '返回首頁',
      text92: '選評時間不能早於活動時間',
      text93: '公布時間不能早於選評時間',
      text94: '',
      text94_1: '編輯得獎作品',
      text95: '',
      text96: '',
      text97: '',
      text98: '',
      text99: '',
      text99_1: '搜尋結果',
      text99_2: '您搜尋的作品或作者不存在',
      text99_3: '暫無作品',
      text100: '',
      text101: '',
      text102: '',
      text102_3: '入選作品',
      text103: '',
      text103_1: '人氣',
      text104: '',
      text105: '',
      text106: '活動封面照',
      text107: '',
      text108: '範例',
      text109: '活動圖片',
      text110: '活動顯示圖片',
      text111: '尺寸：750*480px，最多 5 張並小於 5M。',
      text112: '使用按鈕調整圖片順序',
      text113: '首圖',
      text114: '向下',
      text115: '向上',
      text115_1: '完成',
      text116: '',
      text117: '',
      text118: '',
      text119: '',
      text120: '已更新完成',
      text121: '活动详情',
      text122: '結束',
      time1: '至',
      time2: ['年', '月', '日', '小時', '分'],
      class1: ''
    }
  }
}
